<template>
    <WebInquiryForm id="dataTrackingInquiryModal" :content="content">
        <template #success>
            <CallToAction :text="$dictionary.get('WebInquiry.ModalCloseText')"
                          class="mt-40"
                          @click="handleClickClose"/>
        </template>
    </WebInquiryForm>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { WebInquirySubscribeOverlayOption } from '@/project/modals/overlays/WebInquirySubscribeOverlay.service';
import WebInquiryForm from '@/project/app/blocks/webinquiries/WebInquiryForm.vue';
import { useModal } from '@/project/modals/useModal';
import { IModal } from '@/core/modals/ModalState';

interface WebInquirySubscribeOverlayContent {
    showCommentInput: boolean;
    heading: string;
    bodyText: string;
    commentInputHeader: string;
    commentInputPlaceholderText: string;
    contactConfirmationText: string;
    ctaText: string;
    ctaColor: string;
    successHeading: string;
    successBodyText: string;
    webInquiryOption: WebInquirySubscribeOverlayOption;
}

const props = defineProps({
    modal: {
        type: Object as PropType<IModal>,
        required: true
    },
    content: {
        type: Object as PropType<WebInquirySubscribeOverlayContent>,
        required: true
    }
});
const { modal, closeOverlay } = useModal(props.modal);

function handleClickClose() {
    closeOverlay();
}
</script>
